import * as server from '../../../Axios'

export const getResumen = async q => {
  return await server
    .getResumen(q)
    .then(response => ({ data: response.data }))
    .catch(error => ({ error: error }))
}
